<template>
    <div>
      <national-patent-list></national-patent-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  